/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_2Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An operations workbook refreshes external data and runs a VBA report every morning. The decisive test is whether the automation still runs, not whether the cells look familiar. GridCraft does not execute existing VBA, so keep a supported Excel desktop workflow for that dependency. You can still explore GridCraft with a separate exported data snapshot, provided nobody mistakes that snapshot for the automated source.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运营工作簿可能每天刷新外部数据并运行 VBA 报表。决定性问题是自动化能否继续执行，而不是单元格看起来是否熟悉。GridCraft 不执行现有 VBA，因此这部分依赖应继续使用受支持的 Excel 桌面环境。也可以用独立的数据快照体验 GridCraft，但必须明确快照并非自动更新的源文件。`)
};

/**
* | output |
* | --- |
* | "An operations workbook refreshes external data and runs a VBA report every morning. The decisive test is whether the automation still runs, not whether the c..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_2 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_2(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_2(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_2 as "gc.search_guides.gridcraft_vs_excel.sections.4.paragraphs.2" }